import { ErrorSeverity } from "~/types/errorTypes";

export enum ResponseType {
    success = "200",
    unauthorized = "401",
    internalServerError = "500"
}

export enum RequestType {
    POST = "POST",
    GET = "GET",
    DELETE = "DELETE",
    UPDATE = "UPDATE"
}

export interface ISitecoreResponse<TPayload> {
    success: boolean;
    errorCode: number;
    errorMessage: string;
    errorSeverity?: ErrorSeverity;
    showErrorInModal: boolean;
    payload?: TPayload;
}

export interface IParametersResponsePayload {
    url: string;
    parameters?: Record<string, string>;
    requestType?: string;
}
